var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovedVerification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24 12C24 15.1826 22.7358 18.2349 20.4853 20.4853C18.2349 22.7357 15.1827 24 12.0001 24C8.81748 24 5.76526 22.7357 3.51482 20.4853C1.26438 18.2349 1.00239e-06 15.1826 0 12C0 8.8174 1.26438 5.76516 3.51482 3.51472C5.76526 1.26428 8.81748 0 12.0001 0C15.1827 0 18.2349 1.26428 20.4853 3.51472C22.7358 5.76516 24 8.8174 24 12Z",
    fill: "#18AD91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6399 9.76956L10.6399 14.7699C10.4481 14.9304 10.2031 15.0132 9.95327 15.002C9.70342 14.9908 9.46694 14.8864 9.29028 14.7094L7.29013 12.7093C7.1039 12.5206 6.99986 12.2658 7.00074 12.0007C7.00162 11.7355 7.10738 11.4815 7.29486 11.294C7.48235 11.1065 7.7363 11.0008 8.00145 10.9999C8.26659 10.9991 8.52138 11.1031 8.71011 11.2893L10.0601 12.6492L15.3602 8.22941C15.4609 8.14252 15.5779 8.07658 15.7045 8.03543C15.831 7.99429 15.9644 7.97875 16.097 7.98976C16.2295 8.00076 16.3586 8.03808 16.4766 8.09952C16.5945 8.16096 16.6991 8.24529 16.7842 8.34759C16.8692 8.4499 16.933 8.56813 16.9718 8.69536C17.0107 8.8226 17.0237 8.9563 17.0102 9.08865C16.9968 9.221 16.9572 9.34935 16.8936 9.46619C16.83 9.58304 16.7437 9.68642 16.6399 9.76956Z",
    fill: "#18AD91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedVerification);
export default __webpack_public_path__ + "static/media/approvedVerification.4a2f2cc95c8e2e74befe2f067fa222c8.svg";
export { ForwardRef as ReactComponent };